/**
 * 拼接params生成url
 * @param url
 * @param params
 * @returns
 */
export function generateQS(url, params) {
  var newUrl = new URL(url);
  for (var i in params) {
    if (i) {
      newUrl.searchParams.set(i, params[i]);
    }
  }
  return newUrl.toString();
}
/**
 * 拼接链接参数
 * @param url
 * @param params
 * @returns
 */
export function generateLink(url, params) {
  return generateQS(url, params);
}
/**
 * 通过link生成intent
 * @param url
 * @param packageName
 * @param params
 * @returns
 */
export function generateIntent(url, packageName, fallbackUrl) {
  var intentTail = '';
  if (fallbackUrl) {
    // 指定回退的url
    intentTail = "S.browser_fallback_url=".concat(encodeURIComponent(fallbackUrl), ";");
  }
  var protocol = url.substring(0, url.indexOf('://'));
  // 之前分析过副作用，就是有pkgName的话，
  // 1、如果手机上同时注册两个一样的scheme，系统会跳转到指定pkgName的app
  // 2、如果没有安装，chrome会根据pkgName自动跳转到Google应用市场
  // 没有pkgName的话，
  // 1、chrome一样会执行intent唤端，但如果同时注册两个一样的scheme，会有咨询唤端的对话框
  // 2、如果没有安装，chrome就不会自动跳转Google市场
  var hash = packageName ? "#Intent;scheme=".concat(protocol, ";package=").concat(packageName, ";") : "#Intent;scheme=".concat(protocol, ";");
  var newUrl = url.replace(/.*?:\/\//, 'intent://');
  return "".concat(newUrl + hash + intentTail, "end");
}